export default __webpack_public_path__ + "static/media/10-min.d281efb3.png";